export default __webpack_public_path__ + "static/media/mail-send.05eb9ee2.svg";